<div [ngClass]="{'duration-input-group': showButtons}">
    <button
        *ngIf="showButtons"
        pButton
        type="button"
        (click)="decrementDuration()"
        icon="pi pi-minus"
        severity="danger"
        [outlined]="true"
    ></button>
    <p-calendar
        [(ngModel)]="durationAsDate"
        (onBlur)="setDurationLength()"
        timeOnly="true"
        appendTo="body"
        [showTime]="true"
    ></p-calendar>
    <button
        *ngIf="showButtons"
        pButton
        type="button"
        (click)="incrementDuration()"
        icon="pi pi-plus"
        severity="success"
        [outlined]="true"
    ></button>
</div>
